import { FC } from 'react';

import { FullPageCardLayout } from '../FullPageCardLayout';

import { BuilderGraphic } from './BuilderGraphic';

import classes from './style.module.css';

type OnboardingTemplateProps = {
  children: React.ReactNode;
};

export const OnboardingTemplate: FC<OnboardingTemplateProps> = ({ children }) => (
  <FullPageCardLayout.PageLayout>
    <div className={classes.layout}>
      <BuilderGraphic />
      <div className={classes.form}>{children}</div>
    </div>
  </FullPageCardLayout.PageLayout>
);
